import { toTitleCase } from "../util/toTitleCase";

/**
 * Force Logout Success Banner
 * Shows success message (green) or "already logged out" info (blue)
 * Auto-dismisses after 8 seconds (handled by useForceLogout hook)
 */
const ForceLogoutSuccessBanner = ({ result, clientName }) => {
  if (!result) return null;

  const isAlreadyLoggedOut = result.alreadyLoggedOut;
  const displayName = result.clientFirstName || toTitleCase(clientName);

  return (
    <div
      style={{
        margin: "0 40px 16px 40px",
        padding: "12px 16px",
        backgroundColor: isAlreadyLoggedOut ? "#cce5ff" : "#d4edda",
        border: `1px solid ${isAlreadyLoggedOut ? "#b8daff" : "#c3e6cb"}`,
        borderRadius: "8px",
        color: isAlreadyLoggedOut ? "#004085" : "#155724",
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <span style={{ fontSize: "1.2rem" }}>
        {isAlreadyLoggedOut ? "ℹ️" : "✓"}
      </span>
      <span>
        {isAlreadyLoggedOut ? (
          <>
            <strong>{displayName}</strong> is already logged out of the
            MyCompass app.
          </>
        ) : (
          <>
            <strong>{displayName}</strong> will be logged out when they next
            open the MyCompass app.
          </>
        )}
      </span>
    </div>
  );
};

export default ForceLogoutSuccessBanner;

